import { GraphDataClass } from './GraphDataClass';
/**
 * Represents a single Ensemble
 */
export class EnsembleGraphDataClass extends GraphDataClass {
    constructor(ensembleID, timeSeries, values) {
        super(timeSeries, values);
        this.ensembleID = ensembleID;
    }
    /**
     * Filters the ensemble by its time series.
     * TODO: THE EXISTANCE OF THIS METHOD IS A SIGN OF SOMETHING WRONG
     * @param minTime
     * @param maxTime
     * @returns
     */
    filterByMinMaxDate(minTime, maxTime) {
        let filteredTimeSeries = [];
        let filteredValues = [];
        for (let i = 0; i < this.timeSeries.length; i++) {
            if (this.timeSeries[i] >= minTime && this.timeSeries[i] <= maxTime) {
                filteredTimeSeries.push(this.timeSeries[i]);
                filteredValues.push(this.values[i]);
            }
        }
        return new EnsembleGraphDataClass("1", filteredTimeSeries, filteredValues);
    }
}
